import {Descriptions, Typography} from "antd";
import React from "react";
import {ITOISignal, ITOIStar, PolymorphicItem} from "../../tevapi/interfaces";
import {DescriptionsItemType} from "antd/es/descriptions";


export const TOIDesignation: React.FC<{item: PolymorphicItem}> = ({item}) => {
  const descriptions: Array<DescriptionsItemType> = [];

  let toiStar: ITOIStar | null = null;
  let toiSignal: ITOISignal | null = null;

  if ("atlas" in item) {
    if ("host_star" in item) {
      // Signal
      toiSignal = item.atlas.toi_signal;
      toiStar = item.atlas.toi_signal ? item.atlas.toi_signal.toi_star : null;
    } else {
      toiStar = item.atlas.toi_star;
    }
  } else {
    if ("host_star" in item) {
      toiSignal = item.toi_signal;
      toiStar = item.toi_signal ? item.toi_signal.toi_star : null;
    } else if ("tmag" in item) {
      toiStar = item.toi_star;
    }
  }

  if (toiStar) {
    const toiID = toiStar.toi_identifier.toString().padStart(4, ' ');

    descriptions.push({
      key: "toi_id",
      label: "TOI ID",
      children: toiID,
    });
    if (toiStar && toiSignal) {
      descriptions.push({
        key: "full_toi_id",
        label: "Full TOI ID",
        children: toiSignal.full_toi_id,
      });
      descriptions.push({
        key: "toi_disposition",
        label: "TOI Disposition",
        children: toiSignal.toi_disposition,
      });
      descriptions.push({
        key: "alerted_on",
        label: "Alerted On",
        children: (new Date(toiSignal.alerted_on)).toString(),
      });
    } else if (toiSignal === null) {
      // Signal is _part_ of a TOI system but it itself is not
      // a TOI
      descriptions.push({
        key: "full_toi_id",
        label: "Full TOI ID",
        children: (
          <Typography.Text>
            This signal is part of a TOI system but is not itself
            a TOI.
          </Typography.Text>
        ),
      });
    }
  }
  if (descriptions.length == 0) {
    return null;
  }
  return (<Descriptions
    title="TOI Information"
    bordered
    items={descriptions}
    size="small"
    />
  );
};
